import type { CustomerStore } from "@/Modules/Customers/Store";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { sendMissingEmail } from "@/Services/TherapyApi/Users";

class SendMissingEmailActionHandler {
  constructor(private readonly customerStore: CustomerStore) {}

  public async handle(uuid: string) {
    this.customerStore.isLoading = true;

    try {
      await sendMissingEmail(uuid);

      if (this.customerStore.selected) {
        this.customerStore.selected.lastMissingEmailNotification = new Date().getTime() / 1000;
      }

      this.customerStore.notification = {
        code: null,
        message: "user.settings.customer.connection_notice.success",
        type: NotificationType.SUCCESS,
      };
    } catch (error: unknown) {
      this.customerStore.notification = {
        code: null,
        message: "user.settings.customer.connection_notice.error",
        type: NotificationType.ERROR,
      };
    } finally {
      this.customerStore.isLoading = false;
    }
  }
}

export default SendMissingEmailActionHandler;
